import React from "react";
import "./Faq.css";
import { BiHelpCircle, BiChevronDown, BiChevronUp } from "react-icons/bi";

export default function Faq() {
  return (
    <section id="faq" className="faq section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Frequently Asked Questions</h2>
          {/* <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p> */}
        </div>

        <div className="faq-list">
          <ul>
            <li data-aos="fade-up" data-aos-delay="100">
              <BiHelpCircle className="icon-help" />{" "}
              <a
                data-bs-toggle="collapse"
                className="collapse"
                data-bs-target="#faq-list-1"
              >
                What services does your website development team offer?{" "}
                <BiChevronUp className="icon-show" />
                <BiChevronDown className="icon-close" />
              </a>
              <div
                id="faq-list-1"
                className="collapse show"
                data-bs-parent=".faq-list"
              >
                <p>
                  Our website development services encompass everything from
                  building responsive, user-friendly websites to creating
                  complex web applications. We specialize in crafting tailored
                  digital solutions to suit your unique needs.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="200">
              <BiHelpCircle className="icon-help" />{" "}
              <a
                data-bs-toggle="collapse"
                data-bs-target="#faq-list-2"
                className="collapsed"
              >
                How can data scraping benefit my business?
                <BiChevronUp className="icon-show" />
                <BiChevronDown className="icon-close" />
              </a>
              <div
                id="faq-list-2"
                className="collapse"
                data-bs-parent=".faq-list"
              >
                <p>
                  Data scraping helps extract valuable information from websites
                  and online sources, providing insights for competitive
                  analysis, market research, and decision-making. It streamlines
                  data collection, saving time and effort.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="300">
              <BiHelpCircle className="icon-help" />{" "}
              <a
                data-bs-toggle="collapse"
                data-bs-target="#faq-list-3"
                className="collapsed"
              >
                What sets your UI/UX design team apart?
                <BiChevronUp className="icon-show" />
                <BiChevronDown className="icon-close" />
              </a>
              <div
                id="faq-list-3"
                className="collapse"
                data-bs-parent=".faq-list"
              >
                <p>
                  Our UI/UX designers blend creativity and user-centered design
                  principles to create visually appealing interfaces with
                  exceptional usability. We focus on enhancing user experiences,
                  driving engagement and satisfaction.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="400">
              <BiHelpCircle className="icon-help" />{" "}
              <a
                data-bs-toggle="collapse"
                data-bs-target="#faq-list-4"
                className="collapsed"
              >
                Can you handle both small and large-scale projects?
                <BiChevronUp className="icon-show" />
                <BiChevronDown className="icon-close" />
              </a>
              <div
                id="faq-list-4"
                className="collapse"
                data-bs-parent=".faq-list"
              >
                <p>
                  Absolutely! Whether you have a simple website or a complex web
                  application, our teams are equipped to handle projects of all
                  sizes. We adapt our approach to meet your specific project
                  requirements.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="500">
              <BiHelpCircle className="icon-help" />{" "}
              <a
                data-bs-toggle="collapse"
                data-bs-target="#faq-list-5"
                className="collapsed"
              >
                What is the typical turnaround time for website development
                projects?
                <BiChevronUp className="icon-show" />
                <BiChevronDown className="icon-close" />
              </a>
              <div
                id="faq-list-5"
                className="collapse"
                data-bs-parent=".faq-list"
              >
                <p>
                  The turnaround time varies depending on project complexity. We
                  provide estimated timelines during the project consultation
                  phase and work diligently to meet agreed-upon deadlines.
                </p>
              </div>
            </li>
            <li data-aos="fade-up" data-aos-delay="500">
              <BiHelpCircle className="icon-help" />{" "}
              <a
                data-bs-toggle="collapse"
                data-bs-target="#faq-list-6"
                className="collapsed"
              >
                How do you ensure data scraping is ethical and legal?
                <BiChevronUp className="icon-show" />
                <BiChevronDown className="icon-close" />
              </a>
              <div
                id="faq-list-6"
                className="collapse"
                data-bs-parent=".faq-list"
              >
                <p>
                  We adhere to strict ethical and legal guidelines when scraping
                  data. We respect website terms of use and privacy policies and
                  ensure that data is gathered responsibly and lawfully.
                </p>
              </div>
            </li>
            <li data-aos="fade-up" data-aos-delay="500">
              <BiHelpCircle className="icon-help" />{" "}
              <a
                data-bs-toggle="collapse"
                data-bs-target="#faq-list-7"
                className="collapsed"
              >
                Do you provide ongoing support and maintenance for websites?
                <BiChevronUp className="icon-show" />
                <BiChevronDown className="icon-close" />
              </a>
              <div
                id="faq-list-7"
                className="collapse"
                data-bs-parent=".faq-list"
              >
                <p>
                  Yes, we offer ongoing support and maintenance services to
                  ensure your website remains secure, up-to-date, and
                  functioning optimally. We're here to help you as your digital
                  needs evolve.
                </p>
              </div>
            </li>
            <li data-aos="fade-up" data-aos-delay="500">
              <BiHelpCircle className="icon-help" />{" "}
              <a
                data-bs-toggle="collapse"
                data-bs-target="#faq-list-8"
                className="collapsed"
              >
                What services do your React.js developers offer?
                <BiChevronUp className="icon-show" />
                <BiChevronDown className="icon-close" />
              </a>
              <div
                id="faq-list-8"
                className="collapse"
                data-bs-parent=".faq-list"
              >
                <p>
                  Our React.js developers specialize in creating dynamic and
                  interactive web applications. They build robust user
                  interfaces and ensure seamless, real-time data handling for a
                  wide range of projects.
                </p>
              </div>
            </li>
            <li data-aos="fade-up" data-aos-delay="500">
              <BiHelpCircle className="icon-help" />{" "}
              <a
                data-bs-toggle="collapse"
                data-bs-target="#faq-list-9"
                className="collapsed"
              >
                What is your team's experience with React.js and Node.js?
                <BiChevronUp className="icon-show" />
                <BiChevronDown className="icon-close" />
              </a>
              <div
                id="faq-list-9"
                className="collapse"
                data-bs-parent=".faq-list"
              >
                <p>
                  Our developers have extensive experience working with React.js
                  and Node.js, having successfully completed numerous projects
                  across various industries. They stay up-to-date with the
                  latest trends and best practices.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
